// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__3APgk","filled":"IconReviewStar_filled__3io_3"};